// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__6nDGi","colCheckbox":"styles_colCheckbox__jM3Zk"};